import Modal from 'react-modal'

Modal.setAppElement('body')
